import { faEyeSlash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip, TooltipContent, TooltipTrigger } from '@pickleballinc/react-ui';

export const HiddenAge = () => {
  return (
    <Tooltip placement='bottom'>
      <TooltipTrigger asChild>
        <FontAwesomeIcon icon={faEyeSlash} />
      </TooltipTrigger>
      <TooltipContent className='w-52 rounded bg-black/75 p-2 text-center text-sm text-white'>
        Player age hidden by player
      </TooltipContent>
    </Tooltip>
  );
};
